<app-page-heading [title]="'nav.user-dashboard.sustainability-managers' | translate"></app-page-heading>

<section class="container summary-panel">
    <div class="row">
        <div class="col-md-12">
            <app-data-filters class="pull-left" #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'user-dashboard.users.list.filters.email.helper'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>

            <button class="btn btn-primary btn-lg pull-right" (click)="addRoleToExistingUser(addSustainabilityManagerModal)">
                <span class="fa fa-plus"></span>
                <span [i18n]="'user-dashboard.users.sustainability-managers.list.buttons.add-sustainability-manager'"></span>
            </button>
            <br>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <p [i18n]="'user-dashboard.users.sustainability-managers.list.role-explanation'"></p>
                <div class="ibox-content no-padding">
                    <app-user-table #userTable
                                    [showDelete]="true"
                                    [showEdit]="false"
                                    [showStatus]=false
                                    [loadPage]="loadSustainabilityManagers"
                                    [(filters)]="filters"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    (delete)="openRoleRemovalConfirmationPopup(confirmRoleRemovalModal, $event)">
                    </app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #addSustainabilityManagerModal>
    <p [i18n]="'user-dashboard.users.sustainability-managers.add-role-modal.explanation'"></p>
    <ng-select [items]="chepManagers"
               [bindLabel]="'email'"
               [hideSelected]="true"
               [multiple]="true"
               [(ngModel)]="selectedChepManagers">
    </ng-select>
</ng-template>

<ng-template #confirmRoleRemovalModal>
    <span [i18n]="'user-dashboard.users.sustainability-managers.remove-role-modal.explanation'"></span>
</ng-template>
